import * as types from './constants';

// Upload Link Preview Image
export const uploadLinkPreviewRequest = data => (
  { type: types.UPLOAD_LINK_PREVIEW_REQUEST, payload: data }
);

export const uploadLinkPreviewDone = data => (
  { type: types.UPLOAD_LINK_PREVIEW_DONE, payload: data }
);

export const uploadLinkPreviewFailed = errors => (
  { type: types.UPLOAD_LINK_PREVIEW_FAILED, payload: errors }
);

export const uploadLinkPreviewReset = () => (
  { type: types.UPLOAD_LINK_PREVIEW_RESET }
);
